import { useEffect, useState } from 'react'
import { useTypedSelector } from 'src/State/RootReducer'
import { shouldShowDirectMarketingBanner } from '../../utils'
import useInstallationExtensionData from '../extensions/use-installation-extension-data'

/**
 * This hook checks all conditions for the direct marketing banner and returns if the banner should be shown as a boolean
 */
const useDirectMarketingBannerConditions = (): boolean => {
  const installation = useTypedSelector(state => state.storage.installation)
  const userData = useTypedSelector(state => state.user.userData)
  const installationId = installation?.id?.toString()
  const { installationExtensionsState, isLoading } = useInstallationExtensionData(installationId)

  const [showBanner, setShowBanner] = useState<boolean>(false)

  useEffect(() => {
    if (isLoading) {
      return
    }
    setShowBanner(
      shouldShowDirectMarketingBanner({
        installation,
        userData,
        installationExtensionsState,
      })
    )
  }, [installation, userData, installationExtensionsState, isLoading])

  return showBanner
}

export default useDirectMarketingBannerConditions
